import _ from "lodash";

const mockCodeGroupList = [
  {
    nm: "list1",
    code: "AA",
    description: "list1",
    useYn: "Y",
  },
  {
    nm: "list2",
    code: "BB",
    description: "list2",
    useYn: "Y",
  },
  {
    nm: "list3",
    code: "CC",
    description: "list3",
    useYn: "Y",
  },
  {
    nm: "list4",
    code: "DD",
    description: "list4",
    useYn: "Y",
  },
];

const mockCodeList = [
  {
    nm: "list11",
    code: "AAAA",
    description: "list11",
    useYn: "Y",
  },
  {
    nm: "list12",
    code: "BBBB",
    description: "list12",
    useYn: "Y",
  },
  {
    nm: "list13",
    code: "CCCC",
    description: "list13",
    useYn: "Y",
  },
  {
    nm: "list14",
    code: "DDDD",
    description: "list14",
    useYn: "Y",
  },
];

const initialState = {
  codeList: [],
  codeGroupList: [],
  selectGroupCode: "",
  selectCode: "",
};

/* 코드그룹 로드 */
export const LOAD_CODEGROUP = "LOAD_CODEGROUP";
export const loadCodeGroupAction = (data) => ({
  type: LOAD_CODEGROUP,
});

/* 코드그룹 로드 성공 */
export const LOAD_CODEGROUP_SUCCESS = "LOAD_CODEGROUP_SUCCESS";
export const loadCodeGroupSuccessAction = (data) => ({
  type: LOAD_CODEGROUP_SUCCESS,
});

/* 코드 로드 */
export const LOAD_CODE = "LOAD_CODE";
export const loadCodeAction = (data) => ({
  type: LOAD_CODE,
});

/* 코드 로드 성공 */
export const LOAD_CODE_SUCCESS = "LOAD_CODE_SUCCESS";
export const loadCodeSuccessAction = (data) => ({
  type: LOAD_CODE_SUCCESS,
});

/* 코드그룹 등록 */
export const CODEGROUP_CREATE_REQUEST = "CODEGROUP_CREATE_REQUEST";
export const codeGroupCreateRequestAction = (data) => ({
  type: CODEGROUP_CREATE_REQUEST,
  payload: {
    codeGroupItem: data,
  },
});

/* 코드그룹 등록 성공 */
export const CODEGROUP_CREATE_SUCCESS = "CODEGROUP_CREATE_SUCCESS";
export const codeGroupCreateSuccessAction = (data) => ({
  type: CODEGROUP_CREATE_SUCCESS,
});

/* 코드그룹 수정 */
export const CODEGROUP_MODIFY_REQUEST = "CODEGROUP_MODIFY_REQUEST";
export const codeGroupModifyRequestAction = (data) => ({
  type: CODEGROUP_MODIFY_REQUEST,
  payload: {
    codeGroupItem: data,
  },
});

/* 코드그룹 수정 성공 */
export const CODEGROUP_MODIFY_SUCCESS = "CODEGROUP_MODIFY_SUCCESS";
export const codeGroupModifySuccessAction = (data) => ({
  type: CODEGROUP_MODIFY_SUCCESS,
});

/* 코드그룹 선택 */
export const CODEGROUP_SELECT = "CODEGROUP_SELECT";
export const codeGroupSelectAction = (data) => ({
  type: CODEGROUP_SELECT,
  payload: {
    groupCode: data,
  },
});

/* 코드그룹 삭제 요청 */
export const DELETE_CODEGROUP_REQUEST = "DELETE_CODEGROUP_REQUEST";
export const deleteCodeGroupRequestAction = (data) => ({
  type: DELETE_CODEGROUP_REQUEST,
  payload: {
    groupCode: data,
  },
});

/* 코드그룹 삭제 성공 */
export const DELETE_CODEGROUP_SUCCESS = "DELETE_CODEGROUP_SUCCESS";
export const deleteCodeGroupSuccessAction = (data) => ({
  type: DELETE_CODEGROUP_SUCCESS,
});

/* 코드 등록 */
export const CODE_CREATE_REQUEST = "CODE_CREATE_REQUEST";
export const codeCreateRequestAction = (data) => ({
  type: CODE_CREATE_REQUEST,
  payload: {
    codeItem: data,
  },
});

/* 코드 등록 성공 */
export const CODE_CREATE_SUCCESS = "CODE_CREATE_SUCCESS";
export const codeCreateSuccessAction = (data) => ({
  type: CODE_CREATE_SUCCESS,
});

/* 코드 선택 */
export const CODE_SELECT = "CODE_SELECT";
export const codeSelectAction = (data) => ({
  type: CODE_SELECT,
  payload: {
    code: data,
  },
});

/* 코드 수정 */
export const CODE_MODIFY_REQUEST = "CODE_MODIFY_REQUEST";
export const codeModifyRequestAction = (data) => ({
  type: CODE_MODIFY_REQUEST,
  payload: {
    codeItem: data,
  },
});

/* 코드 수정 성공 */
export const CODE_MODIFY_SUCCESS = "CODE_MODIFY_SUCCESS";
export const codeModifySuccessAction = (data) => ({
  type: CODE_MODIFY_SUCCESS,
});

/* 코드 삭제 */
export const DELETE_CODE_REQUEST = "DELETE_CODE_REQUEST";
export const deleteCodeRequestAction = (data) => ({
  type: DELETE_CODE_REQUEST,
  payload: {
    code: data,
  },
});

/* 코드 삭제 성공 */
export const DELETE_CODE_SUCCESS = "DELETE_CODE_SUCCESS";
export const deleteCodeSuccessAction = (data) => ({
  type: DELETE_CODE_SUCCESS,
});

export default function codeManagementReducer(state = initialState, action) {
  const { type, payload, error } = action;

  //console.log("codeManagementReducer type", type, "payload", payload);

  switch (type) {
    case LOAD_CODEGROUP:
      return {
        ...state,
      };
    case LOAD_CODEGROUP_SUCCESS:
      return {
        ...state,
        codeGroupList: [...mockCodeGroupList],
      };

    case CODEGROUP_CREATE_REQUEST:
      mockCodeGroupList.push(payload.codeGroupItem);

      return {
        ...state,
      };
    case CODEGROUP_CREATE_SUCCESS:
      return {
        ...state,
        codeGroupList: [...mockCodeGroupList],
      };

    case CODEGROUP_MODIFY_REQUEST:
      _.forEach(mockCodeGroupList, (item, i) => {
        if (item.code == payload.codeGroupItem.code) {
          mockCodeGroupList[i] = payload.codeGroupItem;
        }
      });

      return {
        ...state,
      };
    case CODEGROUP_MODIFY_SUCCESS:
      return {
        ...state,
        codeGroupList: [...mockCodeGroupList],
      };
    case CODEGROUP_SELECT:
      return {
        ...state,
        selectGroupCode: payload.groupCode,
      };
    case DELETE_CODEGROUP_REQUEST:
      _.remove(mockCodeGroupList, (item) => {
        return item.code == payload.groupCode;
      });

      return {
        ...state,
      };
    case DELETE_CODEGROUP_SUCCESS:
      return {
        ...state,
        codeGroupList: mockCodeGroupList,
        selectGroupCode: "",
      };
    case LOAD_CODE:
      return {
        ...state,
      };
    case LOAD_CODE_SUCCESS:
      return {
        ...state,
        codeList: state.selectGroupCode ? [...mockCodeList] : [],
      };
    case CODE_CREATE_REQUEST:
      mockCodeList.push(payload.codeItem);

      return {
        ...state,
      };
    case CODE_CREATE_SUCCESS:
      return {
        ...state,
        codeList: [...mockCodeList],
      };
    case CODE_SELECT:
      return {
        ...state,
        selectCode: payload.code,
      };
    case CODE_MODIFY_REQUEST:
      console.log(mockCodeList, payload.codeItem.code);

      _.forEach(mockCodeList, (item, i) => {
        if (item.code == payload.codeItem.code) {
          mockCodeList[i] = payload.codeItem;
        }
      });

      return {
        ...state,
      };
    case CODE_MODIFY_SUCCESS:
      return {
        ...state,
        codeList: [...mockCodeList],
      };
    case DELETE_CODE_REQUEST:
      _.remove(mockCodeList, (item) => {
        return item.code == payload.code;
      });

      return {
        ...state,
      };
    case DELETE_CODE_SUCCESS:
      return {
        ...state,
        codeList: mockCodeList,
        selectCode: "",
      };
    default:
      return state;
  }
}
